import React from "react";
import "./App.css";
import Router from "./router/Router";
import "circular-std";

const App = () => {
  return <Router />;
};

export default App;
